<template>
  <div>
    <h1>Control</h1>

    <h2>{{ responseData  }}</h2>
    <h3>{{ error }}</h3>
  </div>
</template>

<script>

export default {
  name: "Control",
    data() {
    return {
      responseData: null,
      error: null,
    };
  },
  mounted() {
    
    this.fetchData();
  },
  methods: {
    fetchData() {
      // 发送 GET 请求
      const url = "http://127.0.0.1:3000/";
      const formData = {
        username: 'root',
        password: '1234'
      }
      fetch( url + "api/login", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
        .then((data) => {
          // 请求成功，处理返回的数据
          this.responseData = data;
        })
        .catch((error) => {
          // 请求失败，处理错误信息
          this.error = error.message;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/control.vue